import { createRootRouteWithContext, createRoute } from '@tanstack/react-router';

import { ROUTES } from '@/config/routes';
import { RootErrorFallback } from './error-boundary';
import { RootLayout } from './layouts/root-layout';
import { CalibrationPage } from './pages/calibration-page';
import { NewRunPage } from './pages/new-run-page';
import { RunDetailPage } from './pages/run-detail-page';

export const rootRoute = createRootRouteWithContext()({
  component: RootLayout,
  errorComponent: RootErrorFallback,
});

export const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: ROUTES.HOME,
  component: CalibrationPage,
});

export const newRunRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: ROUTES.NEW_RUN,
  component: NewRunPage,
});

export const runDetailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: ROUTES.RUN_DETAIL,
  component: RunDetailPage,
});
